import { useEffect, useState } from 'react';

export const useLoadTimeout = (timeoutMs: number): boolean => {
    const [timedOut, setTimedOut] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => setTimedOut(true), timeoutMs);
        return () => clearTimeout(timer);
    }, [timeoutMs]);
    return timedOut;
};
